/* eslint-disable
    no-param-reassign,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('ui-select');
require('ui-select/dist/select.css');
require('selectize/dist/css/selectize.css');
require('select2/dist/css/select2.css');
require('./select.scss');

const moduleDeps = ['ui.select', require('data/filter/lodashFilters').name];

// example
// <ui-select ng-model='vm.demographics.address.province'>
// <ui-select-match placeholder='State/Province'>{{$select.selected}}</ui-select-match>
// <ui-select-choices repeat="region in vm.regions | filter: $select.search">
// <div ng-bind-html="region | highlight: $select.search"></div>
// </ui-select-choices>
// </ui-select>

module.exports = angular
  .module('bench.ui.form.select', moduleDeps)
  .config(uiSelectConfig => {
    uiSelectConfig.theme = 'selectize';
    return (uiSelectConfig.dropdownPosition = 'down');
  })
  .run($templateCache => {
    $templateCache.put(
      'selectize/select.tpl.html',
      `\
<div class="ui-select-container selectize-control single" ng-class="{'open': $select.open}">
  <div
    class="selectize-input"
    ng-class="{'focus': $select.open, 'disabled': $select.disabled, 'selectize-focus' : $select.focus}" ng-click="$select.activate()">
    <div class="ui-select-match"></div>
    <span ng-if="$select.allowClear && !$select.isEmpty()" class="selectize-input-close" ng-click="$select.select(undefined)"></span>
    <div class="bl-input">
      <input
        id="{{$id}}"
        name="{{$select.placeholder | _camelCase}}"
        type="text"
        autocomplete="false"
        tabindex="-1"
        class="ui-select-search ui-select-toggle"
        ng-click="$select.toggle($event)"
        ng-model="$select.search"
        ng-class="{'empty': $select.isEmpty(), 'non-empty': !$select.isEmpty()}"
        ng-disabled="$select.disabled"/>
      </input>
      <label
        for="{{$id}}"
        placeholder="{{$select.placeholder}}"
        alt="{{$select.placeholder}}">
      </label>
    </div>
  </div>
  <div class="ui-select-choices"></div>
</div>\
`,
    );
    return $templateCache.put(
      'select2/select-multiple.tpl.html',
      `\
<div class="ui-select-container ui-select-multiple select2 select2-container select2-container-multi"
   ng-class="{'select2-container-active select2-dropdown-open open': $select.open,
              'select2-container-disabled': $select.disabled}">
  <ul class="select2-choices">
    <span class="ui-select-match"></span>
    <li class="select2-search-field">
      <input
        id="{{$id}}"
        name="{{$select.placeholder | _camelCase}}"
        type="text"
        autocomplete="false"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        role="combobox"
        aria-expanded="true"
        aria-owns="ui-select-choices-{{ $select.generatedId }}"
        aria-label="{{ $select.baseTitle }}"
        aria-activedescendant="ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}"
        class="select2-input ui-select-search"
        ng-disabled="$select.disabled"
        ng-hide="$select.disabled"
        ng-model="$select.search"
        ng-click="$select.activate()"
        ng-class="{'empty': $select.selected.length == 0, 'non-empty': $select.selected.length != 0}"
        style="width: 34px;"
        ondrop="return false;">
      <label
        for="{{$id}}"
        placeholder="{{$select.placeholder}}"
        alt="{{$select.placeholder}}">
      </label>
    </li>
  </ul>
  <div class="select2-drop select2-with-searchbox select2-drop-active"
       ng-class="{'select2-display-none': !$select.open}">
    <div class="ui-select-choices"></div>
  </div>
</div>\
`,
    );
  });
